import React from 'react';
export function BonusesSection() {
  const bonuses = [{
    emoji: '🎁',
    title: 'Animalitos Amigurumi',
    value: 'Antes $16.500 ARS – HOY GRATIS',
    description: 'Patrones paso a paso para tejer adorables animalitos de forma fácil y divertida.'
  }, {
    emoji: '🌸',
    title: 'Flores Tejidas en Crochet',
    value: 'Antes $27.900 ARS – HOY GRATIS',
    description: 'Aprende a tejer flores para decorar prendas o crear proyectos únicos.'
  }, {
    emoji: '👑',
    title: 'Princesas y Personajes',
    value: 'Antes $18.900 ARS – HOY GRATIS',
    description: 'Diseños inspirados en cuentos clásicos, fáciles de seguir.'
  }, {
    emoji: '🧸',
    title: 'Regalos para Nacimiento',
    value: 'Antes $16.900 ARS – HOY GRATIS',
    description: 'Patrones delicados para bebés y ocasiones especiales.'
  }, {
    emoji: '🎄',
    title: 'Amigurumis Navideños',
    value: 'Antes $27.900 ARS – HOY GRATIS',
    description: 'Diseños temáticos para decorar o regalar en Navidad.'
  }, {
    emoji: '🗓️',
    title: 'Guía para Emprender',
    value: 'Antes $18.900 ARS – HOY GRATIS',
    description: 'Aprende a vender tus tejidos y generar ingresos desde casa.'
  }];
  const totalValue = 16500 + 27900 + 18900 + 16900 + 27900 + 18900;
  return <section className="w-full py-24 px-4 bg-white relative overflow-hidden" data-id="element-15">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-64 bg-secondary/20 -skew-y-3 origin-top-left -z-10" data-id="element-16"></div>

      <div className="max-w-5xl mx-auto" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <h2 className="font-heading font-bold text-4xl md:text-5xl text-textDark mb-6" data-id="element-19">
            Bonos Exclusivos
          </h2>
          <p className="font-body text-xl text-textLight max-w-2xl mx-auto leading-relaxed" data-id="element-20">
            Además del ebook con +7.000 patrones, llevate estos{' '}
            <b data-id="element-21">6 bonos totalmente gratis</b>:
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20" data-id="element-22">
          {bonuses.map((bonus, index) => <div key={index} className="bg-cream rounded-[2rem] p-8 shadow-soft border border-secondary/50 transition-all duration-300 hover:-translate-y-2 hover:shadow-soft-lg group relative overflow-hidden" data-id="element-23">
              {/* Decorative corner */}
              <div className="absolute -top-6 -right-6 w-24 h-24 bg-primary/10 rounded-full blur-xl group-hover:bg-primary/20 transition-colors" data-id="element-24"></div>

              <div className="text-5xl mb-6" data-id="element-25">{bonus.emoji}</div>
              <h3 className="font-heading font-bold text-2xl text-textDark mb-3 leading-snug" data-id="element-26">
                {bonus.title}
              </h3>
              <p className="font-body text-sm text-primary font-bold tracking-wide uppercase mb-4 bg-primary/10 inline-block px-3 py-1 rounded-full" data-id="element-27">
                {bonus.value}
              </p>
              <p className="font-body text-textLight leading-relaxed" data-id="element-28">
                {bonus.description}
              </p>
            </div>)}
        </div>

        {/* Total Value Box */}
        <div className="max-w-3xl mx-auto bg-gradient-to-br from-primary/10 to-accent/10 rounded-[3rem] p-10 md:p-14 text-center shadow-soft-lg border border-primary/20 relative overflow-hidden" data-id="element-29">
          {/* Decorative blobs */}
          <div className="absolute top-0 left-0 w-40 h-40 bg-white/40 rounded-full blur-2xl -translate-x-1/2 -translate-y-1/2" data-id="element-30"></div>
          <div className="absolute bottom-0 right-0 w-40 h-40 bg-white/40 rounded-full blur-2xl translate-x-1/2 translate-y-1/2" data-id="element-31"></div>

          <div className="relative z-10" data-id="element-32">
            <p className="font-heading text-2xl text-textDark italic mb-4" data-id="element-33">
              Valor total de los bonos:
            </p>
            <p className="font-heading font-bold text-5xl md:text-6xl text-textLight line-through mb-6 opacity-70" data-id="element-34">
              ${totalValue.toLocaleString('es-AR')} ARS
            </p>
            <div className="inline-block bg-accent text-white font-heading font-bold text-3xl md:text-4xl px-10 py-4 rounded-full shadow-soft-lg transform -rotate-2" data-id="element-35">
              HOY: GRATIS
            </div>
          </div>
        </div>
      </div>
    </section>;
}